import Vue from 'vue';
import Vuetify, { VBtn, VIcon, VSnackbar } from 'vuetify/lib';
import ru from 'vuetify/es5/locale/ru';
import VuetifyToast from 'vuetify-toast-snackbar-ng';

Vue.use(Vuetify, {
  components: {
    VSnackbar,
    VBtn,
    VIcon
  },
});

Vue.use(VuetifyToast, {
  x        : 'center',
  y        : 'top',
  queueable: true,
});

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  lang : {
    locales: { ru },
    current: 'ru',
  },
});
